import { CREATE_APR, DELETE_APR, GET_APR, UPDATE_APR } from "./types";
import { AprType } from "@type/HRM/apr";

export const createAprRequest = (data: AprType) => {
  return {
    type: CREATE_APR.CREATE_APR_REQUEST,
    payload: {
      data,
    },
  } as const;
};

export const createAprSuccess = (data: AprType) => {
  return {
    type: CREATE_APR.CREATE_APR_SUCCESS,
    payload: {
      data,
    },
  } as const;
};

export const createAprFailed = () => {
  return {
    type: CREATE_APR.CREATE_APR_FAILED,
  } as const;
};

export const getAprRequest = (data: string | number | null) => {
  return {
    type: GET_APR.GET_APR_REQUEST,
    payload: { data },
  } as const;
};

export const getAprSuccess = (data: AprType) => {
  return {
    type: GET_APR.GET_APR_SUCCESS,
    payload: {
      data,
    },
  } as const;
};

export const getAprFailed = () => {
  return {
    type: GET_APR.GET_APR_FAILED,
  } as const;
};

export const updateAprRequest = (data: AprType) =>
  ({
    type: UPDATE_APR.UPDATE_APR_REQUEST,
    payload: {
      data,
    },
  } as const);

export const updateAprSuccess = (data: AprType) =>
  ({
    type: UPDATE_APR.UPDATE_APR_SUCCESS,
    payload: {
      data,
    },
  } as const);

export const updateAprFailed = () =>
  ({
    type: UPDATE_APR.UPDATE_APR_FAILED,
  } as const);

export const deleteAprRequest = (data: {
  aprId: number;
  employeeId: string | number | null;
}) => {
  return {
    type: DELETE_APR.DELETE_APR_REQUEST,
    payload: {
      data,
    },
  } as const;
};

export const deleteAprSuccess = (data: { id: string | number }) =>
  ({
    type: DELETE_APR.DELETE_APR_SUCCESS,
    payload: {
      data,
    },
  } as const);

export const deleteAprFailed = () =>
  ({
    type: DELETE_APR.DELETE_APR_FAILED,
  } as const);

export type AprActions =
  | ReturnType<typeof createAprRequest>
  | ReturnType<typeof createAprSuccess>
  | ReturnType<typeof createAprFailed>
  | ReturnType<typeof getAprRequest>
  | ReturnType<typeof getAprSuccess>
  | ReturnType<typeof getAprFailed>
  | ReturnType<typeof updateAprRequest>
  | ReturnType<typeof updateAprSuccess>
  | ReturnType<typeof updateAprFailed>
  | ReturnType<typeof deleteAprRequest>
  | ReturnType<typeof deleteAprSuccess>
  | ReturnType<typeof deleteAprFailed>;
